/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_LeadInputs */

const en_dr_room_lead = /** @type {(inputs: Dr_Room_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A structured discovery room for teams, agency clients or capstone advisors — six async steps that turn a group chat into a PRD with a traceable origin for every feature.`)
};

const id_dr_room_lead = /** @type {(inputs: Dr_Room_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang discovery terstruktur untuk tim, klien agensi, atau dosen pembimbing — enam langkah asinkron yang mengubah obrolan grup menjadi PRD dengan asal-usul yang bisa ditelusuri untuk setiap fitur.`)
};

/**
* | output |
* | --- |
* | "A structured discovery room for teams, agency clients or capstone advisors — six async steps that turn a group chat into a PRD with a traceable origin for ev..." |
*
* @param {Dr_Room_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_lead = /** @type {((inputs?: Dr_Room_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_lead(inputs)
	return en_dr_room_lead(inputs)
});